/**
 * Session state for one open "Get on the list" (Coming Soon "Get Notified") form
 * (components/getOnTheListForm.js). Module-level singleton — only one lead form is ever mounted
 * at a time (they share the same modal container), so there's never more than one session.
 *
 * Not a Redux slice: this data is purely for tracking (NHS20-8254) and never drives UI.
 */
const state = {
  started: false,
  openedAt: null,
  emailFieldInteracted: false,
  submitted: false,
};

export function startNotifySession() {
  state.started = true;
  state.openedAt = Date.now();
  state.emailFieldInteracted = false;
  state.submitted = false;
}

export function recordEmailFieldInteraction() {
  state.emailFieldInteracted = true;
}

export function markNotifySubmitted() {
  state.submitted = true;
}

export function getElapsedSeconds() {
  if (!state.openedAt) {
    return 0;
  }

  return Math.round((Date.now() - state.openedAt) / 1000);
}

/**
 * Reads live from the DOM (form.elements) rather than from state, so it reflects the form at the
 * exact moment of close.
 * @param {HTMLFormElement|null} formElement
 * @returns {boolean}
 */
export function getEmailEntered(formElement) {
  return Boolean(formElement?.elements?.namedItem('email')?.value);
}

export function getNotifySessionSnapshot() {
  return { ...state };
}

export function resetNotifySession() {
  state.started = false;
  state.openedAt = null;
  state.emailFieldInteracted = false;
  state.submitted = false;
}
